exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control[data-v-42e402d4] {\n  height: calc(1em + .75rem + 2px);\n  padding: 0;\n}\n.vdp-datepicker .form-control[data-v-42e402d4]:disabled,\n.vdp-datepicker .form-control[readonly][data-v-42e402d4] {\n  background-color: white !important;\n}\n.form-control[data-v-42e402d4]:disabled,\n.form-control[readonly][data-v-42e402d4] {\n  background-color: white !important;\n}\n", ""]);

// exports
